/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_No_Connected_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connect an integration from the catalogue and it appears here." |
*
* @param {Integrations_No_Connected_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_no_connected_description = /** @type {((inputs?: Integrations_No_Connected_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_No_Connected_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinde eine Integration aus dem Katalog, dann erscheint sie hier.")
	return /** @type {LocalizedString} */ ("Connect an integration from the catalogue and it appears here.")
});